module.exports = __webpack_public_path__ + "img/pic-01.53355393.png";